export default __webpack_public_path__ + "static/media/information-cirlce-gray.f30f51cf.svg";